import { useState } from "react";
import { Outlet } from "react-router";
import SelectModeSubbarOpener from "../../../Components/Banners/SelectModeBanner/opener";
import DashboardLayout from "../../../Layouts/Dashboard/dashboard";
import ShareBanner from "../../../Components/Banners/ShareBanner";
import { DbShareMediaInfos } from "../../../Core/Api/Types/db-share-media-infos";

function Shares() {
  const [selectedShares, setSelectedShares] = useState<DbShareMediaInfos[]>([]);

  const handleCloseClick = () => {
    setSelectedShares([]);
  };

  return (
    <DashboardLayout
      sxContent={{ px: 2 }}
      Banner={<ShareBanner shares={selectedShares} handleCloseClick={handleCloseClick} />}
    >
      <Outlet
        context={{
          selectedShares: selectedShares,
          setSelectedShares: setSelectedShares,
        }}
      />
      <SelectModeSubbarOpener selectedObjects={selectedShares.map((s) => s.id)} />
    </DashboardLayout>
  );
}

export default Shares;
